var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservedFilterFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#9F70FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4174_44006",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4174_44006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52031 5.53586C8.65759 5.04211 8.74224 4.6122 8.9085 4.21689C8.9596 4.09537 9.23264 4.01923 9.40882 4.01C9.95107 3.98155 10.1143 4.30379 10.1944 5.50664H17.8051C17.8051 5.2713 17.7974 5.03211 17.8066 4.7937C17.8256 4.32225 18.1368 4.00154 18.5654 4.00001C18.9941 3.99847 19.3083 4.31841 19.3289 4.78832C19.3388 5.0175 19.3304 5.24823 19.3304 5.53433C19.9009 5.53433 20.4569 5.56817 21.0075 5.52817C22.5466 5.41512 23.1803 6.13421 23.1651 7.69237C23.1163 12.5107 23.1476 17.3297 23.1468 22.1488C23.1468 23.4332 22.5862 24 21.3141 24C16.42 24 11.526 24 6.63193 24C5.41014 24 4.83203 23.4193 4.83203 22.1927C4.83203 17.2328 4.83203 12.273 4.83203 7.31321C4.83203 6.1319 5.41929 5.53663 6.58388 5.53509C7.2558 5.53356 7.92695 5.53509 8.52031 5.53509V5.53586ZM21.5909 10.1427V7.0971H19.3319C19.3319 7.34475 19.3388 7.57239 19.3304 7.80004C19.3129 8.29226 18.9918 8.62219 18.5494 8.61142C18.1223 8.60066 17.8226 8.27764 17.8058 7.80081C17.7974 7.56393 17.8043 7.32706 17.8043 7.09864H10.1738C10.1738 7.36167 10.1837 7.60316 10.1715 7.84311C10.1478 8.29302 9.84049 8.6022 9.42559 8.61066C8.99697 8.61912 8.67284 8.29995 8.65072 7.83388C8.63928 7.59393 8.64843 7.35321 8.64843 7.10095H6.39017V10.1427H21.5902H21.5909ZM12.9705 17.9435C12.3558 17.3544 11.7792 16.796 11.1935 16.2469C11.0661 16.1269 10.9189 16.01 10.7595 15.9469C10.4483 15.8239 10.0739 15.9746 9.89311 16.2569C9.69253 16.5722 9.74515 16.9675 10.0525 17.2651C10.7946 17.9835 11.5443 18.6933 12.2909 19.407C12.7913 19.8854 13.1398 19.8908 13.6348 19.4216C14.8467 18.2719 16.0562 17.1213 17.2666 15.97C17.5068 15.7416 17.7601 15.5247 17.9812 15.2794C18.2649 14.9648 18.2466 14.5295 17.9683 14.2365C17.6876 13.9419 17.2689 13.9158 16.9371 14.1857C16.7693 14.3219 16.6183 14.4788 16.4612 14.628C15.3065 15.7247 14.1519 16.8214 12.9712 17.9427L12.9705 17.9435Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedFilterFill);
export default __webpack_public_path__ + "static/media/reserved_filter_fill.1c83f4edf7754706a15f3827ab8e4e92.svg";
export { ForwardRef as ReactComponent };